import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as ChatTag } from '../../../assets/images/ChatImages/chattag.svg';
import { ReactComponent as SelctedTag } from '../../../assets/images/TicketImages/label-tag.svg';
import { fetchTags } from '../../../store/features/tagsApi';
import { addTagsToChat } from '../../../store/features/addTagsToChat';
import useClickOutside from '../../../hooks/useClickOutside';
import SearchInput from '../../common/SearchInputField';
import { CircularProgress } from '@mui/material';
import NoSearch from '../../common/NoSearch';

function TagMenu({
  selectedTagIds = [],
  onSelectTag,
  onClose,
  roomId,
  maxTags = 5,
}) {
  const dispatch = useDispatch();
  const { list: availableTags = [], loading } = useSelector((state) => state.tags);
  const { loginToken, loginTokenCoUser } = useSelector((state) => state);
  const businessId =
    loginToken?.response?.user?.business_id ||
    loginTokenCoUser?.response?.user?.business_id;
  const [search, setSearch] = React.useState('');

  const menuRef = useRef(null);

  useClickOutside(menuRef, () => {
    if (onClose) onClose();
  });

  useEffect(() => {
    if (businessId) {
      dispatch(fetchTags({ businessId, type: "conversation" }));
    }
  }, [dispatch, businessId]);

  const filteredTags = search.trim()
    ? availableTags.filter((tag) => tag.name.toLowerCase().includes(search.trim().toLowerCase()))
    : availableTags;

  const handleTagClick = async (tagId) => {
    let newSelected;
    if (selectedTagIds.includes(tagId)) {
      newSelected = selectedTagIds.filter((id) => id !== tagId);
    } else {
      if (selectedTagIds.length >= maxTags) return;
      newSelected = [...selectedTagIds, tagId];
    }
    
    if (onSelectTag) {
      onSelectTag(newSelected);
    }
    
    if (roomId) {
      try {
        await dispatch(
          addTagsToChat({
            room_id: roomId,
            tag_ids: newSelected,
            business_id: businessId,
          }),
        ).unwrap();
      } catch (error) {
        console.error('Error adding tags to chat:', error);
        if (onSelectTag) {
          onSelectTag(selectedTagIds);
        }
      }
    }
  };

  const tagListMaxHeight = 5 * 40; // 200px

  return (
    <div className="dropdown-chat-tag" ref={menuRef}>
        <SearchInput
         title=""
          placeholder="Search tags"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      {loading ? (
      
          
          <CircularProgress
            style={{ display: 'block', margin: 'auto', padding: '20px' }}
            size={24}
          />
                ) : (
        <div
          style={{
            maxHeight: `${tagListMaxHeight}px`,
            overflowY: filteredTags.length > 5 ? 'auto' : 'visible',
            marginTop: '8px',
          }}
        >
          <ul style={{ padding: 0, margin: 0 }}>

            {filteredTags.length > 0 ?
            filteredTags.map((tag) => (
              <li
                key={tag._id}
                style={{
                  display: 'flex',
                  gap: '8px',
                  alignItems: 'center',
                  padding: '9px 10px',
                  cursor: 'pointer',
                  borderRadius: '4px',
                  background: selectedTagIds.includes(tag._id) ? '#F0F4F8' : 'transparent',
                }}
                onClick={() => handleTagClick(tag._id)}
              >
                  {selectedTagIds.includes(tag._id) ? (
                    <SelctedTag />
                  ) : (
                    <ChatTag />
                  )}
                {tag.name.slice(0, 17) + (tag.name.length > 17 ? '...' : '')}
              </li>
            ))
            :
             <NoSearch
             title="No tags found"
             description="Create new tags or search for existing ones"
             titleFontSize={14}
             descriptionFontSize={12}
           
             />
            }
          </ul>
        </div>
      )}
    </div>
  );
}
export default TagMenu;
